import './WeddingDetails4.css';
import venueImg from '../assets/venue.png';
import holmatImg from '../assets/holmat.png';
import copyImg from '../assets/copy.png';
import igIcon from '../assets/ig.png';
import Space from './Space';

const WeddingDetails4 = ({ inviteType }) => {
    const handleCopy = async () => {
        const accountNumber = '4790270512';
        await navigator.clipboard.writeText(accountNumber);
        alert('Account number copied to clipboard!');
    };

    return (
        <div className="section wedding-details-section">
            {(inviteType === 'holmat_reception' || inviteType === 'open') && (
                <div>
                    <div className="title-container">
                        <h1 className="cLight w100">THE RECEPTION</h1>
                    </div>

                    <img className="placeholder-image" src={venueImg} alt="venue" />

                    <div className="details-container">
                        <p className="cLight w300">SATURDAY, 7 JUNE 2025</p>
                        <p className="cLight w300">18:00 WIB</p>
                    </div>

                    <div className="details-container">
                        <p className="cLight w300">THE GELADERI</p>
                        <p className="cLight w300">Jl. Teratai, Komp. Villa Melati Mas No.12</p>
                        <p className="cLight w300">Kota Tangerang Selatan</p>
                    </div>

                    <div className="details-container">
                        <a href="https://maps.app.goo.gl/miN6A8vJ5sjfEBur9" target="_blank" rel="noopener noreferrer">
                            <p className="cLight w500 underline">Get Directions</p>
                        </a>
                    </div>

                    <Space s={128} />
                </div>
            )}
            <div className="title-container">
                <h1 className="cLight w100">THE HOLY MATRIMONY</h1>
            </div>

            <img className="placeholder-image" src={holmatImg} alt="holmat" />

            <div className="details-container">
                <p className="cLight w300">SATURDAY, 7 JUNE 2025</p>
                <p className="cLight w300">10:00 WIB</p>
            </div>

            <div className="details-container">
                <p className="cLight w300">THE GELADERI</p>
                <p className="cLight w300">Jl. Teratai, Komp. Villa Melati Mas No.12</p>
                <p className="cLight w300">Kota Tangerang Selatan</p>
            </div>

            <div className="details-container">
                <a href="https://maps.app.goo.gl/miN6A8vJ5sjfEBur9" target="_blank" rel="noopener noreferrer">
                    <p className="cLight w500 underline">Get Directions</p>
                </a>
            </div>

            <Space s={128} />

            <div className="title-container">
                <h1 className="cLight w100">LIVE STREAMING</h1>
            </div>
            <div className="details-container">
                <p className="cLight w300">
                    If you are unable to join us in person, we would still love for you to be part of our special day.
                    You can celebrate with us by tuning in to our live stream.
                </p>
                <Space s={32} />
                <div className="button-container">
                    <div
                        className="button"
                        onClick={() => window.open('https://www.instagram.com/ericsucitra/', '_blank')}
                    >
                        <img src={igIcon} alt="ig" className="ig-icon" />
                        <p className="cLight w300">@ericsucitra</p>
                    </div>

                    <div
                        className="button"
                        onClick={() => window.open('https://www.instagram.com/jessycaputrikartiadi/', '_blank')}
                    >
                        <img src={igIcon} alt="ig" className="ig-icon" />
                        <p className="cLight w300">@jessycaputrikartiadi</p>
                    </div>
                </div>
            </div>

            <Space s={128} />

            <div className="title-container">
                <h1 className="cLight w100">GIFTS FOR THE GROOM AND BRIDE</h1>
            </div>
            <div className="details-container">
                <p className="cLight w300">
                    Your presence is our greatest gift, but if you wish to bless us, gifts are warmly welcomed—feel free
                    to bring them on the day or send a contribution to the number below.
                </p>
                <Space s={32} />
                <div className="account-number-container">
                    <h2 className="cLight w300 space-out">4790270512</h2>
                    <img src={copyImg} alt="copy" className="copy-icon" onClick={handleCopy} />
                </div>
                <p className="cLight w300">BCA a/n Eric Sucitra</p>
            </div>
        </div>
    );
};

export default WeddingDetails4;
